module.exports = __webpack_public_path__ + "img/charging-station-infographic-mobile.fd0bb165.webp";